import React, { PropTypes } from "react";
import InsurerSection from "./InsurerSection";
import { Field } from "redux-form";
import { FormattedMessage } from "react-intl";
import { TextInput } from "../../../../common/form";

const InsurerAccounts = () => (
  <InsurerSection>
    <h3>
      <FormattedMessage id="admin.insurers.form.accounts.acombaTitle" />
    </h3>
    <Field
      id="acombaProviderNumber"
      name="acombaProviderNumber"
      component={TextInput}
      type="text"
      label={
        <FormattedMessage id="admin.insurers.form.accounts.providerNumber" />
      }
    />
  </InsurerSection>
);

InsurerAccounts.propTypes = {
  translateFn: PropTypes.func,
};

export default InsurerAccounts;



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/insurers/formSections/InsurerAccounts.js